module.exports = __webpack_public_path__ + "static/media/ex-p2p-img1.15558f05.svg";